import {CategoriesChildrenEntity} from "./categories-children-entity";

export class CategoriesEntity {
  id: number;
  name: string;
  logo: string;
  children: CategoriesChildrenEntity[];
  checked?: boolean;
  constructor(categoriesEntity: object) {
    Object.assign(this,  categoriesEntity)
    // @ts-ignore
    if (categoriesEntity && categoriesEntity[`children`]) {
    // @ts-ignore
      this.children = categoriesEntity[`children`].map((item: CategoriesChildrenEntity ) => new CategoriesChildrenEntity(item));
    }
  }
}
